import { ref } from "vue";
import { preparedCaption } from "@/composables/useChartUpload";
/** What the prepare job did to each uploaded document, by link, for as long as the page lives. */
export function usePreparedInfo() {
    const preparedInfo = ref({});
    const remember = (link, facts) => {
        if (facts.sizeBytes === undefined)
            return;
        preparedInfo.value[link] = {
            sizeBytes: facts.sizeBytes,
            droppedPages: facts.droppedPages ?? [],
            pageRanges: facts.pageRanges,
        };
    };
    const captionFor = (link) => preparedInfo.value[link] ? preparedCaption(preparedInfo.value[link]) : null;
    return { remember, captionFor };
}
